// startup
// Load entry module and return exports
__webpack_require__("./src/polyfill/Array.fill.js");
__webpack_require__("./src/polyfill/Array.find.js");
__webpack_require__("./src/polyfill/Array.findIndex.js");
__webpack_require__("./src/polyfill/Array.includes.js");
__webpack_require__("./src/polyfill/DOMMatrix.js");
__webpack_require__("./src/polyfill/Element.closest.js");
__webpack_require__("./src/polyfill/Element.matches.js");
__webpack_require__("./src/polyfill/Element.replaceChildren.js");
__webpack_require__("./src/polyfill/Intl.Collator.js");
__webpack_require__("./src/polyfill/Intl.DateTimeFormat.js");
__webpack_require__("./src/polyfill/Intl.NumberFormat.js");
__webpack_require__("./src/polyfill/Math.log10.js");
__webpack_require__("./src/polyfill/Math.trunc.js");
__webpack_require__("./src/polyfill/Object.assign.js");
__webpack_require__("./src/polyfill/Object.entries.js");
__webpack_require__("./src/polyfill/Object.is.js");
__webpack_require__("./src/polyfill/Object.values.js");
__webpack_require__("./src/polyfill/Promise.js");
__webpack_require__("./src/polyfill/Promise.all.js");
__webpack_require__("./src/polyfill/Promise.finally.js");
__webpack_require__("./src/polyfill/String.endsWith.js");
__webpack_require__("./src/polyfill/String.includes.js");
__webpack_require__("./src/polyfill/String.padEnd.js");
__webpack_require__("./src/polyfill/String.padStart.js");
__webpack_require__("./src/polyfill/String.repeat.js");
__webpack_require__("./src/polyfill/String.replaceAll.js");
__webpack_require__("./src/polyfill/String.startsWith.js");
__webpack_require__("./src/polyfill/Symbol.js");
__webpack_require__("./src/polyfill/URLSearchParams.js");
__webpack_require__("./src/polyfill/crypto.js");
__webpack_require__("./src/polyfill/fetch.js");
__webpack_require__("./src/polyfill/localStorage.js");
__webpack_require__("./src/polyfill/requestAnimationFrame.js");
__webpack_require__("./src/polyfill/scrollBehavior.js");
__webpack_require__("./src/vue.js");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./src/init.js");
var __webpack_exports__ = __webpack_require__("./src/index.js");
